import React from 'react';
import { Button, Stack, Box, TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useState } from 'react';
import { login } from './request';
import { setToken } from './action/user';
import { connect } from 'react-redux';
import { useNavigate } from "react-router";
import { FormGroup } from '@mui/material';
import { addFormError } from './action/error';

const Login = ({setToken, addFormError}) => {
    const navigate = useNavigate();

    const [values, setValues] = useState({
        password: '',
        username: '',
        showPassword: false,
    });

    const onChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const onClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };

    const onMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const onSubmit = async () => {
        try{
            const info = await login({ username: values.username, password: values.password });

            setToken(info.accessToken);
            navigate('/');
        }catch(e){
            addFormError(e.message);
        }
    }

    return <Box sx={{ p: 2, border: '1px dashed grey', justifyContent: 'center' }} className='login-form'>
        <Stack spacing={2}>
        <TextField label="Username" onChange={onChange('username')}></TextField>
        <FormControl  variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
            <OutlinedInput
                id="outlined-adornment-password"
                type={values.showPassword ? 'text' : 'password'}
                value={values.password}
                onChange={onChange('password')}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={onClickShowPassword}
                            onMouseDown={onMouseDownPassword}
                            edge="end"
                        >
                            {values.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
                label="Password"
            />
        </FormControl>
        <Button variant="contained" onClick={onSubmit}>Login</Button>
        </Stack>
     </Box> ;
};

const mapDispatchToProps = (dispatch) => ({
    addFormError: (message) => dispatch(addFormError(message)),
    setToken: (accessToken) => dispatch(setToken({accessToken}))
});

export default connect(undefined, mapDispatchToProps)(Login);